var l = /* @__PURE__ */ ((i) => (i.Bold = "bold", i.Italic = "italic", i.Underline = "underline", i.Strike = "strike", i))(l || {});
export {
  l as TextFormatEnum
};
